<template>
  <div v-loading="loading" class="wrap">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>账户管理</el-breadcrumb-item>
      <el-breadcrumb-item>修改密码</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <div class="demo-input-suffix">
        原密码：
        <el-input
          placeholder="请输入原密码"
          suffix-icon="el-icon-lock icon"
          show-password
          v-model="password"
        >
        </el-input>
      </div>
      <div class="demo-input-suffix">
        新密码：
        <el-input
          placeholder="请输入新密码"
          suffix-icon="el-icon-lock icon"
          show-password
          v-model="newPassword"
        >
        </el-input>
      </div>
      <div class="btn">
        <el-button @click="submit" type="primary">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: '',
      newPassword: '',
      loading: false,
    };
  },
  methods: {
    async submit(){
      if(!this.password){
        this.$message({
          message: '原密码不能为空！',
          type: 'warning'
        })
        return
      }
      if(!this.newPassword){
        this.$message({
          message: '新密码不能为空！',
          type: 'warning'
        })
        return
      }

      var patrn=this.GLOBAL.passwordRegular 
      if (!patrn.exec(this.newPassword)){
        this.$message({
          message: '新密码格式不正确！',
          type: 'warning'
        })
        return
      }

      let params = {
        password: this.password,
        newPassword: this.newPassword
      }
      this.loading = true;
      let res = await this.$Http.updatePassword(params);
      if(res.code==0){
        this.$message({
          message: "修改成功",
          type: "success",
        });
        this.password='';
        this.newPassword='';
      }else{
        this.$message.error(res.msg);
      }
      this.loading = false;
    }
  },
};
</script>
<style scoped>
.wrap {
  padding: 0 20px;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-sizing: border-box;
}
.container{
  width:300px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
}
.btn{
  margin-top:15px;
}
</style>